<script lang="ts">
	import InputsCompany from './InputsCompany.svelte';
	import InputSelectCountry from './InputSelectCountry.svelte';
	import { setContext } from 'svelte';
	import { writable } from 'svelte/store';
	import { findPropsByApiKey } from '@app/utils/kyc';
	import type { KYCQuestionProps } from '@app/models/api/KYCModel';
	import InputSelect from '@app/components/inputs/AppInputSelect.svelte';
	import { InputText } from '@wiseed/wikit';
	import { FunctionOfTheLegalRepresentativeEnumFR } from '@app/models/api/enums/FunctionOfTheLegalRepresentativeEnum';
	export let props;

	let isForeignCompany = writable(false);

	$: setContext('isForeignCompany', isForeignCompany);

	let registrationCountryProps: KYCQuestionProps;
	let companyNameProps: KYCQuestionProps;
	let legalFormProps: KYCQuestionProps;
	let SIRENProps: KYCQuestionProps;
	let SIRETProps: KYCQuestionProps;
	let registrationCityProps: KYCQuestionProps;
	let businessLineProps: KYCQuestionProps;
	let addressCompany: KYCQuestionProps;
	let companyPostalCodeProps: KYCQuestionProps;
	let companyCityProps: KYCQuestionProps;
	let companyCountryProps: KYCQuestionProps;
	let functionOfTheLegalRepresentativeProps: KYCQuestionProps;
	let otherFunctionOfTheLegalRepresentativeProps: KYCQuestionProps;
	$: if (props?.questions) {
		registrationCountryProps = findPropsByApiKey(props?.questions, 'immatriculationPays');
		companyNameProps = findPropsByApiKey(props?.questions, 'denomination');
		legalFormProps = findPropsByApiKey(props?.questions, 'formeJuridique');
		functionOfTheLegalRepresentativeProps = findPropsByApiKey(
			props?.questions,
			'representantLegalFonction'
		);
		otherFunctionOfTheLegalRepresentativeProps = findPropsByApiKey(
			props?.questions,
			'representantLegalFonctionAutre'
		);
		SIRENProps = findPropsByApiKey(props?.questions, 'immatriculationNumero');
		SIRETProps = findPropsByApiKey(props?.questions, 'immatriculationSiret');
		registrationCityProps = findPropsByApiKey(props?.questions, 'immatriculationVille');
		businessLineProps = findPropsByApiKey(props?.questions, 'secteurActivite');
		addressCompany = findPropsByApiKey(props?.questions, 'adresse');
		companyPostalCodeProps = findPropsByApiKey(props?.questions, 'codePostal');
		companyCityProps = findPropsByApiKey(props?.questions, 'ville');
		companyCountryProps = findPropsByApiKey(props?.questions, 'pays');
	}

	$: if (
		FunctionOfTheLegalRepresentativeEnumFR[functionOfTheLegalRepresentativeProps?.value] ===
		FunctionOfTheLegalRepresentativeEnumFR.AUTRE
	) {
		otherFunctionOfTheLegalRepresentativeProps.required = true;
	}
	$: $isForeignCompany = !(
		registrationCountryProps?.value === 'FRA' || !registrationCountryProps?.value
	);
	$: if (registrationCountryProps?.value)
		companyCountryProps.value = { ...registrationCountryProps }.value;
</script>

<div class="text-left space-y-4">
	<InputSelect bind:props={legalFormProps} />
	<InputSelect bind:props={functionOfTheLegalRepresentativeProps} />
	{#if FunctionOfTheLegalRepresentativeEnumFR[functionOfTheLegalRepresentativeProps?.value] === FunctionOfTheLegalRepresentativeEnumFR.AUTRE}
		<InputText bind:props={otherFunctionOfTheLegalRepresentativeProps} />
	{/if}
	{#if registrationCountryProps}<InputSelectCountry bind:props={registrationCountryProps} />{/if}

	<InputsCompany
		bind:nameProps={companyNameProps}
		bind:sirenProps={SIRENProps}
		bind:siretProps={SIRETProps}
		bind:cityOfRegistration={registrationCityProps}
		bind:businessLine={businessLineProps}
		bind:addressCompany
		bind:companyCityProps
		bind:postalCode={companyPostalCodeProps}
		bind:companyPostalCodeProps
		bind:companyCountryProps
	/>
</div>
